<template>
    <div id="monitor-stations">
        <v-card v-if="Object.keys(station_data).length" 
            class="base-popup__wrapper"
        >
            <div id="base-popup__capture_range" 
                class="base-popup__container"
                :class="{ 'base-popup__container--hide-tooltip': !is_show_control_options}"
            >
                <div v-if="is_show_control_options" 
                    class="base-popup__tooltip"
                >
                    <div class="base-popup__tooltip-title">
                        <div class="base-popup__tooltip-title__city_info">
                            <h1>{{ zone_selected }}</h1>
                        </div>
                        <v-btn
                            class="base-popup__tooltip-close-btn"
                            color="white"
                            icon
                            @click="close_dialog"
                        >
                            <v-icon color="white">
                                icon-close
                            </v-icon>
                        </v-btn>
                    </div>
                    <div class="base-popup__tooltip-selection">
                        <div class="selection-input">
                            <v-select
                                v-model="rain_selected"
                                :items="rain_select"
                                id="tsgraph-select-type"
                                item-text="text"
                                item-value="value"
                                label="雨量累積時間"
                            />
                        </div>
                        <div class="selection-input">
                            <v-select
                                v-model="zone_selected"
                                :items="zone_select"
                                id="tsgraph-select-day"
                                item-text="text"
                                item-value="value"
                                :label="zone_label"
                            />
                        </div>
                    </div>
                </div>
                <div class="base-popup__content">
                    <div class="base-popup__content-detail d-flex justify-space-between">
                        <div class="d-flex align-center">
                            {{ is_pad_width ? props_svg_sub_title.time : props_svg_sub_title.full_title }}
                            <v-btn v-if="!is_mobile_width"
                                id="tsgraph-reset-btn" 
                                icon
                            />
                        </div>
                        <div>
                            <v-btn v-if="!is_mobile_width"
                                id="tsgraph-download" 
                                @click="save_png"
                                icon
                            >
                                <v-icon color="black">
                                    icon-file-download
                                </v-icon>
                            </v-btn>
                            <v-btn v-if="is_show_control_options"
                                class="close-btn"
                                color="black"
                                icon
                                @click="close_dialog"
                            >
                                <v-icon color="black">
                                    mdi-close
                                </v-icon>
                            </v-btn>
                        </div>
                        <v-menu v-if="is_mobile_width" 
                            offset-y
                        >
                            <template #activator="{ on, attrs }">
                                <v-btn
                                    color="black"
                                    dark
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>icon-more</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="save_png">
                                    <v-icon color="black">
                                        icon-file-download
                                    </v-icon>
                                    {{ $t('__chart_common.save_image') }}
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    <div 
                        class="base-popup__content-legend"
                    >
                        <span class="legend histogram" /> 累積雨量
                        <span class="legend no-data-label">&#10010;</span> {{ $t('__chart_common.legend_no_data') }}
                    </div>
                    <div class="base-popup__content-graph">
                        <QpeHistogram
                            :id="id"
                            ref="chart"
                            :x_axis_band_data="x_axis_station_data"
                            :choosed_band_data="choosed_station_data"
                            :basic_layout_setting="basic_layout_setting"
                            :x_axis="x_axis"
                            :y_axis="y_axis"
                            :is_wrap_tick="is_wrap_tick"
                        />
                    </div>
                </div>
            </div>
        </v-card>
        <v-card v-else>
            <v-alert
                :value="true"
                type="error"
                class="alert"
            >
                暫時無法顯示歷史圖表
            </v-alert>
        </v-card>
    </div>
</template>

<script>
    import { judge_value_valid } from '@/utils/chart/verification.js'
    import * as d3 from 'd3';
    import QpeHistogram from '@/components/chart/qpe_histogram.vue'

    export default {
        name: 'MonitorStations',
        
        components: {
            QpeHistogram
        },    

        props: {
            id: {
                type: String,
                default() {
                    return 'unique_chart'
                }
            },
            station_data: {
                type: Array,
                default () {
                    return []
                }
            },
            // zone span 對應的是 table header
            zone_span: {
                type: String,
                default () {
                    return ''
                }
            },

            zone_table_value: {
                type: String,
                default () {
                    return ''
                }
            },

            date: {
                type: String,
                require: true,
            },

            time: {
                type: String,
                require: true,
            },

            is_show_control_options: {
                type: Boolean,
                default () {
                    return true
                }
            },

            rain_init_value: {
                type: String,
                default() {
                    return '3小時'
                }
            },

            chart_height: {
                type: Number,
                default() {
                    return 0
                }
            },

            is_wrap_tick: {
                type: Boolean,
                default() {
                    return false
                }
            }
        }, 

        data() {
            return {
                rain_selected: this.rain_init_value,
                rain_select: ['10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'],

                // 從 api 來
                zone_selected: '',

                x_axis: {
                    'label': '雨量站',
                    'ticks': 48,
                    'display_interval': 2,
                    'label_distance': 50
                },
                y_axis: {
                    'label': '降雨量(mm)',
                    'ticks': 10,
                    'display_interval': 1,
                    'min_value': 0,
                    'label_distance': 40
                },
            }
        },
        
        computed: {
            zone_label() {
                return `選擇${this.zone_span}`
            },

            props_svg_sub_title() {                
                return {
                    full_title: `${this.zone_selected} ${this.rain_selected}累積雨量測站比較圖`,
                    zone: `${this.zone_selected}`,
                }
            },

            basic_layout_setting() {
                return {
                    'margin': {
                        'top': 25,
                        'right': 50,
                        'bottom': 55,
                        'left': 30,
                    }
                }
            },

            zone_select() {
                return [...new Set(this.station_data.map(datum => datum[this.zone_span]))]
            },

            x_axis_station_data() {
                return this.station_data
                    .filter(datum => datum[this.zone_span] === this.zone_selected )
                    .map(datum => datum['站名'])
            },

            choosed_station_data() {
                return this.station_data
                    .filter(datum => datum[this.zone_span] === this.zone_selected )
                    .map(datum => datum[this.rain_selected])
            },

            is_mobile_width() {
                return window.innerWidth < 769;
            },

            is_pad_width() {
                return window.innerWidth < 1025;
            },
        },

        watch: {
            zone_table_value: {
                handler() {
                    this.zone_selected = this.zone_table_value
                },
                immediate: true
            },

            choosed_station_data: {
                handler() {
                    this._calc_y_axis_max_min()
                    this.rerender_svg()
                },
                immediate: true
            }
        },

        methods: {
            // 也有可能從上層 call
            rerender_svg() {
                setTimeout(() => {
                    this.$refs.chart.rerender_svg()
                }, 0);
            },

            close_dialog() {
                this.$emit('close-chart-dialog');
            },
            
            save_png() {
                const file_name = `${this.props_svg_sub_title.zone}_${d3.timeFormat('%Y%m%d')(new Date())}`
                this.$refs.chart.save_png(file_name)
            },

            _calc_y_axis_max_min() {
                this.y_axis.min_value = 0

                const ignore_None_data = this.choosed_station_data
                    .filter(val => judge_value_valid(val))
                const max_data_value = Math.max(...ignore_None_data)
                const MAX_RANGE = [10, 50, 100 , 300 , 500, 1000]
                const NAN_MAX_VALUE = 50
                this.y_axis.max_value = MAX_RANGE.find(value => value >= max_data_value) || NAN_MAX_VALUE
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../css/base_popup';

    .legend {
        margin: 2px 5px;
    }

    .histogram {
        display: inline-block;
        width: 1rem;
        height: 1rem;
        background-color: #4682b4;
    }

    .no-data-label {
        transform: rotate(45deg);
        font-weight: bold;
        color: #f00;
    }

    .line {
        display: inline-block;
        width: 2rem;
        border-top: 5px solid #4682b4;
        margin-bottom: 4px;
    }

    @mixin triangle-base {
        width: 0;
        height: 0;
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
    }

    .triangle {
        &__wind-max {
            @include triangle-base;

            border-top: 15px solid #f00;
        }

        &__wind-min {
            @include triangle-base;

            border-bottom: 15px solid #ffa500;
        }

        &__gust-max {
            @include triangle-base;

            border-top: 15px solid #00f;
        }
    }

    .cross {
        font-weight: bold;
        color: #00f;
    }

    .gust_time {
        font-size: .8rem;
        color: rgb(128, 0, 128);
    }

    .back-station-title {
        margin-bottom: .25rem;

        @include laptop {
            position: absolute;
            top: 0;
            left: 16px;
        }

        &__text {
            font-size: .75rem;
            letter-spacing: .5px;
            line-height: 1.33;

            @include laptop {
                display: none;
            }
        }
    }

    .base-popup {
        &__tooltip-title__city_info {
            margin-left: .25rem;
        }

        &__container--hide-tooltip {
            display: block;
        }
    }
</style>

<style lang="scss">

    @mixin time_slider_psuedo_comment {
        content: '';
        position: absolute;
        margin-top: 12px;
        width: var(--slider-pseudo-width);
        height: 8px;
        background: var(--grey-border);
        border-radius: 9ex;
    }

    .base-popup {
        .time-slider {
            width: 100%;
            text-align: center;

            &__content {
                position: relative;
                display: inline-block;
                width: var(--slider-width);

                &-container {
                    display: inline-block;
                    margin-left: calc(1rem + var(--slider-pseudo-width));
                    text-align: center;
                }

                &-before {
                    @include time_slider_psuedo_comment;

                    transform: translateX(calc(-100% + 1rem));
                }

                &-after {
                    @include time_slider_psuedo_comment;

                    transform: translateX(-1rem);
                }
            }

            &__icon {
                transform: translateY(-50%);

                &::before {
                    margin: 0 .1rem;
                }

                &-container {
                    margin-left: calc(var(--slider-pseudo-width) - .5rem);
                }
            }
        }
    }

    #monitor_stations .v-slider__thumb {
        transform: translate(-50%, -50%);
        width: var(--slider-thumb-width);
        height: 8px;
        border-radius: 12px;
        z-index: 1;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .32);
        background-image: linear-gradient(to right, #124ed0 0%, #2366f8 99%);

        &::before {
            content: none;
        }

        &::after {
            content: 'lll';
            position: absolute;
            transform: translate(calc(var(--slider-thumb-width) / 2 - 50%), -40%);
            color: #fff;
        }
    }

    #monitor_stations .v-slider__track-container {
        margin: 0 0 0 1px;
        height: 8px !important;
        background-color: var(--grey-border);

        .v-slider__track-background {
            background-color: var(--grey-border) !important;
        }

        .v-slider__track-fill {
            background-color: var(--grey-border) !important;
        }
    }

    .v-slider__ticks-container {
        .v-slider__tick {
            background-color: var(--grey-border) !important;
            
            &--filled {
                background-color: var(--grey-border) !important;
            }

            &-label {
                height: 14px;
                font-size: 11px;
                font-family: NotoSansCJKtc;
                letter-spacing: .5px;
                line-height: 1.27;
                color: var(--grey-pipe);
            }
        }
    }

    .back-station-title {
        .v-btn--icon.v-size--default {
            width: 1.5rem;
        }

        .v-btn::before {
            transform: translateX(-.65rem);
            width: 2rem;
        }

        .v-btn__content {
            margin-right: .75rem;
        }
    }
</style>